<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<odc-spinner [stateResource]="twoFactorDevicesStateResource()" spinnerSize="large">
  @if (twoFactorDevicesStateResource().resource) {
    <ods-overview-list-page
      data-test-id="two-factor-devices"
      heading="Zwei-Faktor-Authentifizierung"
      [headingLevel]="2"
      [badgeConfig]="badgeConfig()"
      newButtonText="Gerät hinzufügen"
      buttonDataTestId="add-device-button-native"
      emptyListText="Schützt Ihren Zugang zusätzlich mit einem Einmalcode."
      [isEmpty]="devices().length === 0"
      (newButtonClick)="addDevice.emit()"
    >
      <ods-card list>
        @for (device of devices(); track device.id) {
          <ods-card-item data-test-class="device">
            <ods-card-col
              [title]="getDeviceName(device)"
              [attr.data-test-id]="'device-' + (getDeviceName(device) | convertForDataTest)"
            />
            <ods-card-col-right>
              <administration-device-actions
                data-test-class="device-actions"
                [deviceName]="getDeviceName(device)"
                [deviceLabel]="device.userLabel"
                [renameStateResource]="renameStateResource()"
                [deleteStateResource]="deleteStateResource()"
                (renamed)="renameDevice.emit({ credentialId: device.id, label: $event })"
                (deleted)="deleteDevice.emit(device.id)"
              />
            </ods-card-col-right>
          </ods-card-item>
        }
      </ods-card>
    </ods-overview-list-page>
  }
</odc-spinner>
